import { useState } from 'react';
import PropTypes from 'prop-types';

import { API_HOST } from '../../../utils/api-util';
import { getClassNames, noOp } from '../../../utils/util';

import './image.scss';

const Image = ({ externalReference, file, className, alt, onClick }) => {
  const [loading, setLoading] = useState(true);

  let src = `${API_HOST}/file/retrieve/${externalReference}`;

  if (file) {
    src = URL.createObjectURL(file);
  }

  return (
    <img
      className={`${getClassNames('image', { loading })} ${getClassNames(className, { loading })}`}
      src={src}
      alt={alt}
      onLoad={() => setLoading(false)}
      onClick={onClick}
    />
  );
};

Image.propTypes = {
  externalReference: PropTypes.string,
  file: PropTypes.shape({}),
  className: PropTypes.string,
  alt: PropTypes.string,
  onClick: PropTypes.func,
};

Image.defaultProps = {
  externalReference: undefined,
  file: undefined,
  className: '',
  alt: '',
  onClick: noOp,
};

export default Image;
